import { AxiosPromise, AxiosResponse } from 'axios';

import { api } from 'api';
import { ShortBrandedGiftCard } from 'features/my-gift-cards/ts/ShortBrandedGiftCard';
import { FullBrandedGiftCard } from 'features/my-gift-cards/ts/FullBrandedGiftCard';
import type { IdType } from 'ts/IdType';
import { GCCurrency } from 'features/my-gift-cards/ts/GCCurrency';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';

export const getMyGiftCardsRequest = (filters: { brand_name?: string }): AxiosPromise<ShortBrandedGiftCard[]> =>
  api.get(`/giftcards/own-branded-gift-cards/`, { params: filters });

export const getFullGiftCardRequest = (id: IdType): AxiosPromise<FullBrandedGiftCard> =>
  api.get(`/giftcards/branded-gift-cards/${id}/`);

export const createGiftCardRequest = (card: FormData): AxiosPromise<FullBrandedGiftCard> =>
  api.post(`/giftcards/branded-gift-cards/create/`, card);

export const editGiftCardRequest = (cardId: IdType, card: FormData): AxiosPromise<FullBrandedGiftCard> =>
  api.patch(`/giftcards/branded-gift-cards/${cardId}/edit/`, card);

export const getCurrenciesRequest = (search?: string): AxiosPromise<GCCurrency[]> => {
  return from(api.get('/products/currencies/', { params: { search } }))
    .pipe(
      map(({ data, ...rest }: AxiosResponse<(GCCurrency & { id: IdType })[]>) => ({
        ...rest,
        data: data.map(({ id, ...restItem }) => ({ ...restItem, currency_id: id })),
      }))
    )
    .toPromise();
};

export const getCardPreviewTemplateRequest = (): AxiosPromise<string> =>
  api.get(`/giftcards/branded-gift-cards/email-template/`);

export const deleteGiftCardRequest = (id: IdType): AxiosPromise<void> =>
  api.delete(`/giftcards/branded-gift-cards/${id}/`);
